import React, { useContext } from 'react';
import Input from 'chameleon/ui-stack/ui/base/input';
import DynamicBuilderContext from '../context';

const labelClassName = 'ml-2 mb-2 text-14 font-medium';

const SpecificDynamicBuilder = () => {
  const { formData, onInputChange } = useContext(DynamicBuilderContext);
  const { buckets } = formData;

  return buckets.map((tagCategory) => (
    <div key={tagCategory.label} className="mb-6">
      <p className="mb-2 text-16 font-bold">{tagCategory.label}</p>
      {tagCategory.buckets.map((bucket) => (
        <div key={`${tagCategory.label}-${bucket.label}`} className="mb-6">
          <p className="mb-2 text-16 font-medium">{bucket.label}</p>
          <div className="flex justify-between gap-16">
            <div className="flex gap-8">
              <div>
                <label className={labelClassName}>Min. MCQs</label>
                <Input
                  className={{ 'input-field-invalid': false }}
                  type="number"
                  min={0}
                  step={1}
                  value={bucket.mcq.min}
                  onChange={onInputChange('buckets', bucket, 'mcq.min')}
                />
              </div>
              <div>
                <label className={labelClassName}>Max. MCQs</label>
                <Input
                  className={{ 'input-field-invalid': false }}
                  type="number"
                  min={0}
                  step={1}
                  value={bucket.mcq.max}
                  onChange={onInputChange('buckets', bucket, 'mcq.max')}
                />
              </div>
            </div>
            <div className="flex gap-8">
              <div>
                <label className={labelClassName}>Min. FRQs</label>
                <Input
                  className={{ 'input-field-invalid': false }}
                  type="number"
                  min={0}
                  step={1}
                  value={bucket.frq.min}
                  onChange={onInputChange('buckets', bucket, 'frq.min')}
                />
              </div>
              <div>
                <label className={labelClassName}>Max. FRQs</label>
                <Input
                  className={{ 'input-field-invalid': false }}
                  type="number"
                  min={0}
                  step={1}
                  value={bucket.frq.max}
                  onChange={onInputChange('buckets', bucket, 'frq.max')}
                />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  ));
};

export default SpecificDynamicBuilder;
